<template>
  <div>
  <div class="nav-box">
    <div class="navbar d-flex justify-space-between align-center">
      <div class="_left d-flex">
        <div class="logo" @click="go('/')">
          <img src="@/assets/logo.png" />
        </div>
      </div>
      <div class="_right d-flex align-center cursor">
        <div class="_title _ablout" >
          <span @click="go('/')">For Users</span>
          <div class="_menu">
            <div class="menu-item" @click="go('/howHeart')">Why Heart Smart™</div>
            <div class="menu-item" @click="go('/howWork')">How Heart Smart™ Works</div>
          </div>
        </div>
        <!-- <div class="_title _product" >
          <span @click="go('howWork')">For Providers</span>
        </div> -->
        <div class="_title _health">
          <span @click="go('/support')">Contact Us</span>
          <!-- <div class="_menu">
            <div class="menu-item" @click="go('/support')">Contact Us</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="place"></div>
</div>
</template>

<script>
export default {
  name: "navbar",
  data() {
    return {

    };
  },
  methods: {
    go(path) {
      this.$router.push(path)
    }
  }
};
</script>

<style lang="less" scoped>

.nav-box{
  width: 100%;
  background: #fff;
  box-shadow: 0px 0px 4px #efefef;
  position: fixed;
  top: 0;
  z-index: 999;
}
.navbar {
  width: 100%;
  max-width: 1920px;
  height: 133px;
  padding: 0px 276px 0 276px;
  font-family: "Light";
  margin: 0 auto;
  ._left,
  ._right {
    height: 100%;
  }
  .logo {
    cursor: pointer;
    display: flex;
    align-items: center;
    img{
      width: 252px;
      margin-top: 15px;
    }
  }
  ._title {
    height: 100%;
    font-size: 22px;
    color: #373536;
    cursor: pointer;
    transition: all 0.2s;
    padding-top: 65px;
    position: relative;
    &:hover {
      color: #50c88c;
      ._menu{
        display: block;
      }
    }
    ._menu{
      position: absolute;
      top: 80%;
      left: -20%;
      width: max-content;
      background: #fff;
      box-shadow: 0px 0px 4px #efefef;
      display: none;
      padding: 15px 30px;
      .menu-item{
        height: 50px;
        line-height: 50px;
        cursor: pointer;
        transition: all 0.2s;
        border-bottom: 1px solid #A5A4A7;
        color: #373536;
        &:last-child{
          border-bottom: none;
        }
        &:hover{
          color: #50c88c;
        }
      }
    }
  }
  ._ablout {

  }
  ._product {
    margin-left: 60px;
  }
  ._health {
    margin-left: 63px;
  }
}
.place{
  height: 133px;
}
/* 桌面显示器，小于 1200px） */
@media (max-width: 1200px) {
  .navbar {
    padding: 0px 66px 0 66px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/pc/components/navbar.vue